import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=cd30e6ba&scoped=true"
import script from "./Disclaimer.vue?vue&type=script&setup=true&lang=js"
export * from "./Disclaimer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&id=cd30e6ba&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd30e6ba",
  null
  
)

export default component.exports